export type NumberAggregate = {
  current: number;
  median: number;
  min: number;
  max: number;
  average: number;
  mode: number;
};

export function average(numbers: number[]) {
  return numbers.reduce((a, b) => a + b, 0) / numbers.length;
}

export function median(numbers: number[]) {
  const sorted = Array.from(numbers).sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);

  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2;
  }

  return sorted[middle];
}

export function maxFreqNumber(array) {
  const counts = new Map();

  let maxCount = 0;
  let maxNumber = 0;

  for (const element of array) {
    const count = (counts.get(element) || 0) + 1;
    counts.set(element, count);

    if (count > maxCount || (count === maxCount && element > maxNumber)) {
      maxCount = count;
      maxNumber = element;
    }
  }

  return maxNumber || 0;
}

export function getAggregate(numbers: number[], current: number): NumberAggregate | null {
  if (numbers.length === 0) {
    return null;
  }

  return {
    current,
    median: median(numbers),
    min: Math.min(...numbers),
    max: Math.max(...numbers),
    average: average(numbers),
    mode: maxFreqNumber(numbers)
  };
}
